import { ID, IdFilterType } from '../../../../../types';
import { FetchItemTagsFilters } from '../../../../../main/itemTags/itemTagsTypes';

export const enum UniversalFilterItemTagsModes {
  // CONTAINS_ANY_OF = 'contains_any_of'
  CONTAINS_ALL_OF = 'contains_all_of'
  // CONTAINS_ONLY = 'contains_only',
  // CONTAINS_NONE_OF = 'contains_none_of',
  // DOES_NOT_CONTAIN_ANY_OF = 'does_not_contain_any_of',
  // IS_EMPTY = 'is_empty',
  // IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterItemTagsValue = IdFilterType;

export type UniversalFilterItemTagsFilterState = {
  mode: UniversalFilterItemTagsModes;
  itemTagIds?: ID[];
};

export type UniversalFilterItemTagsFilterOptions = {
  initialItemTagsFilters?: FetchItemTagsFilters;
};

export type UniversalFilterItemTagsOnFilterStateChange = (
  state: UniversalFilterItemTagsFilterState
) => void;

export type UniversalFilterItemTagsOnChange = (
  value?: UniversalFilterItemTagsValue
) => void;
